"use client"

import { useState, useTransition } from "react"
import type { User } from "@apps/gwservice/types"
import { MemberCard } from "./member-card"
import { SearchFilter } from "~/components/search-filter"

interface Props {
  members: User[]
}

export function MembersFeed({ members }: Props) {
  const [query, setQuery] = useState("")
  const [isPending, startTransition] = useTransition()

  const filtered = query
    ? members.filter(
        (member) =>
          member.name?.toLowerCase().includes(query.toLowerCase()) ||
          member.company?.toLowerCase().includes(query.toLowerCase()),
      )
    : members

  return (
    <div className="flex flex-col">
      <SearchFilter
        value={query}
        onChange={(value) => startTransition(() => setQuery(value))}
        isPending={isPending}
        placeholder="Поиск участников..."
      />
      <div className={`flex flex-col gap-s p-m transition-opacity ${isPending ? "opacity-50" : ""}`}>
        {filtered.map((member) => (
          <MemberCard key={member.id} user={member} />
        ))}
      </div>
    </div>
  )
}
